export default function ({state, getters, rootState, commit, dispatch}, data) {
  return new Promise((resolve, reject) => {
    let rData = '';
    for (let k in data) {
      rData += k + '=' + data[k] + '&';
    }
    rData += 'Columns=3&Columns=4&Columns=5&Columns=6&Columns=7&Columns=8&Columns=12&Columns=15&Columns=16';
    rootState.balanceSheet.settings.columns.forEach(i => {
      if (i.name === 'Name' && i.visible) rData += '&Columns=2';
      if (i.name === 'CurrencyName' && i.visible) rData += '&Columns=9';
      if (i.name === 'RateName' && i.visible) rData += '&Columns=10';
      if (i.name === 'PartnerName' && i.visible) rData += '&Columns=13';
      if (i.name === 'PaymentAccount' && i.visible) rData += '&Columns=14';
      if (i.name === 'DepartmentName' && i.visible) rData += '&Columns=17';
    });
    axios({
      method: 'post',
      url: '/tourclient/balanceSheet/create',
      data: rData,
      requestId: 'tourclient/balanceSheet/create'
    }).then(({data}) => {
      commit('set', data.Rows);
      resolve(state);
    }).catch(e => {
      dispatch('error', e, {root: true});
      reject(e);
    })
  });
}